import {
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React from "react";

import NumberFormat from "react-number-format";
import { DoneIcon } from "./StepIcons";
import TransactionHistoryBase from "./TransactionHistoryBase";
import styles from "./styles";
import "./style.scss";
import {
  getCompletedRelated,
  formatUTCtoMYTDateTime,
  formatUTCtoMYTDate,
} from "./utils";


const SalesCharge = ({
  salesChargeAmount,
  salesChargePercent,
  serviceTaxRate,
  serviceTaxAmount,
  amount,
  fee,
}) => {
  return (
    <>
      <div
        style={{
          marginTop: "3px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
          }}
        >
          Total Cash In
        </Typography>
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
          }}
        >
          <NumberFormat
            prefix="RM"
            value={(amount) + fee}
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale
          />
        </Typography>
      </div>

      <div
        style={{
          marginTop: "3px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
          }}
        >
          Sales Charge ({salesChargePercent || 0}%)
        </Typography>
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
          }}
        >
          <NumberFormat
            prefix="RM"
            value={salesChargeAmount || 0}
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale
          />
        </Typography>
      </div>
      {/* START: SST */}
      {
        <div
          style={{
            marginTop: "3px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            SST ({serviceTaxRate || 0}%)
          </Typography>
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            <NumberFormat
              prefix="RM"
              value={serviceTaxAmount || 0}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale
            />
          </Typography>
        </div>
      }
      {/* END: SST */}
      <div
        style={{
          marginTop: "3px",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "700",
          color: "#616367",
        }}
      >
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
            fontWeight: "inherit",
            color: "inherit",
          }}
        >
          Net amount
        </Typography>
        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
            fontWeight: "inherit",
            color: "inherit",
          }}
        >
          <NumberFormat
            prefix="RM"
            value={amount - salesChargeAmount}
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale
          />
        </Typography>
      </div>
    </>
  );
};

const BonusUnits = ({
  status,
  amount,
  unit,
  fee,
  submittedDate,
  processingDate,
  completedDate,
  details,
  salesChargeAmount,
  salesChargePercent,
  transactionType,
}) => {
  const completed = getCompletedRelated({
    status,
    isDoneIconActive: status === "5" || status === "10",
  });

  const isSubmitted =
    status === "3" ||
    status === "4" ||
    status === "5" ||
    status === "6" ||
    status === "9" ||
    status === "10" ||
    status === "11";

  const isProcessing =
    status === "4" ||
    status === "5" ||
    status === "9" ||
    status === "10" ||
    status === "11";

  const isCompleted =
    status === "5" || status === "9" || status === "10" || status === "11";

  const isFailed = status === "9";

  const { serviceTaxAmount = 0, serviceTaxRate = 0 } =
    (Array.isArray(details) && details.at(0)) || {};

  return (
    <TransactionHistoryBase
    >
      {/* Submitted */}
      <Step active={isSubmitted}>
        <StepLabel
          icon={<DoneIcon active={isSubmitted} />}
          sx={{ padding: "0" }}
        >
          <Typography
            color="textPrimary"
            style={{ ...styles.baseFont, ...styles.label }}
          >
            Submitted
          </Typography>
        </StepLabel>
        <StepContent
          style={{
            borderColor: isSubmitted && "#0091DA",
            borderWidth: 2,
            height: "100%",
            paddingBottom: "24px",
          }}
        >
          <Typography style={{ ...styles.baseFont, ...styles.content }}>
            Your Bonus Units amount has been successfully
            submitted.
          </Typography>
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
              marginTop: "8px",
            }}
          >
            Transaction Method: Bonus Units
          </Typography>

          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
              ...styles.date,
              marginTop: "8px",
            }}
          >
            {formatUTCtoMYTDateTime(submittedDate)}
          </Typography>
        </StepContent>
      </Step>

      {/* Processing */}
      <Step active={isProcessing}>
        <StepLabel
          icon={<DoneIcon active={isProcessing} />}
          sx={{ padding: "0" }}
        >
          <Typography
            color="textPrimary"
            style={{
              ...styles.baseFont,
              ...styles.label,
              color: isProcessing ? "#000000" : "#9D9EA4",
            }}
          >
            Processing
          </Typography>
        </StepLabel>
        <StepContent
          sx={{
            borderColor: isProcessing && "#0091DA",
            borderWidth: 2,
            height: "100%",
            paddingBottom: "24px",
          }}
        >
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
              ...styles.date,
              marginTop: "8px",
            }}
          >
            {processingDate !== null && formatUTCtoMYTDateTime(processingDate)}
          </Typography>
        </StepContent>
      </Step>

      {/* Completed */}
      <Step active={isCompleted}>
        <StepLabel icon={completed.icon} sx={{ padding: "0" }}>
          <Typography
            color="textPrimary"
            style={{
              ...styles.baseFont,
              ...styles.label,
              color:
                status === "5" || status === "9" || status === "10"
                  ? "#000000"
                  : "#9D9EA4",
            }}
          >
            {completed.text}
          </Typography>
        </StepLabel>
        <StepContent
          style={{
            borderColor: isCompleted && "#0091DA",
            borderWidth: 2,
            marginTop: "0",
            height: "100%",
            // paddingBottom:
            //   ((details.length > 0 && details[0].adjustments.length > 0) ||
            //     (Array.isArray(corrections) && corrections.length > 0)) &&
            //   "24px",
          }}
        >
          <>
            <Typography style={{ ...styles.baseFont, ...styles.content }}>
              {isFailed  && "Bonus Unit is unsuccessful."}
            </Typography>
            {isFailed ? (
              <Typography
                style={{
                  ...styles.baseFont,
                  ...styles.content,
                  ...styles.date,
                  marginTop: "8px",
                }}
              >
                {completedDate !== null && formatUTCtoMYTDate(completedDate)}
              </Typography>
            ) : (
              <>
                <SalesCharge
                    amount={amount}
                    fee={fee}
                    salesChargeAmount={salesChargeAmount}
                    salesChargePercent={salesChargePercent}
                    serviceTaxAmount={serviceTaxAmount}
                    serviceTaxRate={serviceTaxRate}
                />
                <div
                    style={{
                    marginTop: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    }}
                >
                    <Typography style={{ ...styles.baseFont, ...styles.content }}>
                    Unit: {unit}
                    </Typography>
                    <Typography
                    style={{
                        ...styles.baseFont,
                        ...styles.content,
                        textAlign: "right",
                    }}
                    >
                    Unit Price:{" "}
                    <NumberFormat
                        prefix="RM"
                        value={
                        details.length > 0 &&
                        details[0].actualUnitPrice !== null
                            ? details[0].actualUnitPrice
                            : parseFloat(amount / unit)
                        }
                        thousandSeparator
                        displayType="text"
                        decimalScale={4}
                        fixedDecimalScale
                    />
                    </Typography>
                </div>

              </>
            )}

            {(isFailed || status === "5") && (
              <Typography
                style={{
                  ...styles.baseFont,
                  ...styles.content,
                  ...styles.date,
                  marginTop: "8px",
                }}
              >
                {formatUTCtoMYTDate(completedDate)}
              </Typography>
            )}
          </>
        </StepContent>
      </Step>


    </TransactionHistoryBase>
  );
};

export default BonusUnits;
